/* Disabled fields for phase 1 */
import React, { useState, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CardWrap from "../Common/CardWrap";
import ResultModal from "../Common/ResultModal";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import SpinnerLoading from "../Common/SpinnerLoading";
import NumberFormat from "react-number-format";
import {
  itemServices,
  globalServices,
  posServices,
  storeService,
} from "../../Services";
import Tooltip from "../Common/Tooltip";
import { convertToDecimalString } from "../../Helpers/DecimalNumberHelper";
import { roles } from "../../Config/Roles";
import NullTaxRateModal from "./NullTaxRateModal";
import {
  knToEuroConverter,
  euroToKnConverter,
} from "../../Helpers/CurrencyConverter";
import { currencyPriceList, currencyTagSessionName } from "../../Config/Consts";

const initState = {
  createInAllPriceLists: false,
  name: "",
  code: "",
  barCode: "",
  description: "",
  isService: false,
  pn: null,
  unitOfMeasureId: -1,
  taxRateId: -1,
  itemId: -1,
  price: null,
  pp: null,
  itemGroupId: -1,
  isPriceLocked: false,
};

const EditRawMaterial = ({ match }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { locName, locTenant, locStore, locPos } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { cashier, manager, accountant } = roles;
  const priceListId = match.params.priceListId;
  const itemId = match.params.itemId;
  const currencyTag = sessionStorage.getItem(currencyTagSessionName);

  const history = useHistory();
  const { t: translator } = useTranslation();

  const { register, handleSubmit, errors, control, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const [item, setItem] = useState({ ...initState, currencyTag: currencyTag });

  const [unitOfMeasures, setUnitOfMeasures] = useState([]);
  const [itemGroups, setItemGroups] = useState([]);

  const [tenantTaxObligation, setTenantTaxObligation] = useState(false);
  const [resultModal, setResultModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  React.useEffect(() => {
    if (locPos != 0) {
      posServices
        .getById(locPos)
        .then((res) => {
          setTenantTaxObligation(res.data.tenantTaxObligation);
        })
        .catch((err) => setTenantTaxObligation(false));
    } else {
      storeService
        .getById(locStore)
        .then((res) => setTenantTaxObligation(res.data.tenantTaxObligation))
        .catch((err) => setTenantTaxObligation(false));
    }

    if ([cashier, manager, accountant].includes(Number(roleId)))
      history.push("/error-page/401");

    globalServices
      .getUnitOfMeasures()
      .then((res) => setUnitOfMeasures(res.data));

    globalServices.getItemGroups(Number(locTenant)).then((res) => {
      setItemGroups(res.data);
    });

    if (itemId) {
      setIsLoading(true);
      itemServices
        .getById(priceListId, itemId)
        .then((data) => {
          setItem({
            itemId: data.data.itemId,
            priceListItemId: data.data.priceListItemId,
            name: data.data.name,
            barCode: data.data.barCode,
            code: data.data.code,
            description: data.data.description,
            isService: data.data.isService,
            itemGroupId: data.data.itemGroupId,
            pn: data.data.pn,
            pp: data.data.pp,
            price: data.data.price,
            currencyTag: data.data.currencyTag,
            taxRateId: data.data.taxRateId,
            unitOfMeasureId: data.data.unitOfMeasureId,
            isPriceLocked: false,
            currencyId: data.data.currencyId,
            normativeTypeId: data.data.normativeTypeId,
            isRawMaterial: true,
          });
          setIsLoading(false);
        })
        .catch((err) => console.log("error", err));
    }
  }, []);

  const handleCloseResultModal = () => {
    setResultModal({ show: false, warningText: null });
    if (resultModal.success === true) {
      goBack();
    }
  };

  const onSubmit = (data) => {
    if (itemId) {
      itemServices
        .update({
          itemId: itemId,
          priceListId: priceListId && Number(priceListId),
          name: data.name,
          code: "",
          barCode: "",
          description: "",
          isService: false,
          pn: 0,
          unitOfMeasureId: Number(data.unitOfMeasureId),
          taxRateId:
            Number(data.taxRateId) == -1 ? null : Number(data.taxRateId),
          changePriceByTaxRate: false,
          itemGroupId: Number(data.itemGroupId) == -1 ? null : data.itemGroupId,
          priceListItemId: item.priceListItemId,
          price: parseFloat(convertToDecimalString(data.priceInput)),
          pp: parseFloat(data.pp),
          isPriceLocked: false,
          isRawMaterial: item.isRawMaterial ?? false,
          normativeTypeId: 1
        })
        .then((res) => {
          res.data.success
            ? setResultModal({
              show: true,
              title: translator("EditItem-UpdateItem-SuccesModal-Title"),
              text: translator("EditItem-UpdateItem-SuccesModal-Text"),
              warningText:
                item.isPriceLocked &&
                item.currencyTag === currencyPriceList.kn &&
                translator("EditItem-UpdateItem-SuccessModal-WarningText"),
              btnClass: "btn btn-primary",
              success: true,
            })
            : setResultModal({
              show: true,
              title: translator("EditItem-Update-UnsuccessModal-Title"),
              text: translator("EditItem-Update-UnsuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
        })
        .catch((err) =>
          setResultModal({
            show: true,
            title: translator("EditItem-Update-UnsuccessModal-Title"),
            text: translator("EditItem-Update-UnsuccessModal-Text"),
            btnClass: "btn btn-primary",
            success: false,
          })
        );
    } else {
      itemServices
        .create({
          tenantId: locTenant && Number(locTenant),
          createInAllPriceLists: false,
          priceListId: priceListId && Number(priceListId),
          name: data.name,
          code: "",
          barCode: "",
          description: "",
          isService: false,
          pn: parseFloat(convertToDecimalString(data.pnInput)),
          unitOfMeasureId: Number(data.unitOfMeasureId),
          taxRateId: null,
          itemGroupId: Number(data.itemGroupId) == -1 ? null : data.itemGroupId,
          price: null,
          pp: 0,
          isPriceLocked: false,
          currencyId: currencyPriceList[currencyTag],
          isRawMaterial: true,
          normativeTypeId: 1,
        })
        .then((res) => {
          res.data.success
            ? setResultModal({
              show: true,
              title: translator("EditItem-AddNewItem-SuccesModal-Title"),
              text: translator("EditItem-AddNewItem-SuccesModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
            : setResultModal({
              show: true,
              title: translator("EditItem-Add-UnsuccessModal-Title"),
              text: translator("EditItem-Add-UnsuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
        })
        .catch((err) =>
          setResultModal({
            show: true,
            title: translator("EditItem-Add-UnsuccessModal-Title"),
            text: translator("EditItem-Add-UnsuccessModal-Text"),
            btnClass: "btn btn-primary",
            success: false,
          })
        );
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    goBack();
  };

  const goBack = () => {
    switch (locName) {
      case "stores":
        history.push(`/${locName}/${locStore}`);
        break;
      case "pos":
        history.push(`/${locName}/${locPos}`);
        break;
      default:
        history.push("/error");
    }
  };

  const currencyConverter = (currencyTag, value) => {
    return currencyTag === currencyPriceList.euro
      ? euroToKnConverter(value)
      : knToEuroConverter(value);
  };
  const handleChangeRawMaterial = () => {
    if (item.isService) {
      setItem({
        ...item,
        isService: false,
        isRawMaterial: true,
      });
    } else setItem({ ...item, isRawMaterial: true });
  };

  return (
    <CardWrap
      title={translator("EditItem-Title-ItemManagement")}
      subtitle={
        itemId
          ? translator("EditItem-Subtitle-UpdateRawMaterial")
          : translator("EditItem-Subtitle-NewRawMaterial")
      }
    >
      {tenantTaxObligation == false ? (
        <div
          style={{ margin: 5, marginBottom: "20px" }}
          className="alert alert-warning"
          role="alert"
        >
          {translator("Tenant-FiscalObligation")}
        </div>
      ) : (
        ""
      )}

      {isLoading && <SpinnerLoading />}
      {!isLoading && (
        <form onSubmit={handleSubmit(onSubmit)} className="row">
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("EditItem-ArticleData")}
              </legend>
              <div className="form-group">
                <label className="labelCont">
                  <input
                    type="checkbox"
                    name="isRawMaterial"
                    defaultChecked={true}
                    onChange={handleChangeRawMaterial}
                    disabled={true}
                  />
                  <span className="checkmark"></span>
                </label>
                <span>{translator("EditItem-RawMaterial")}</span>{" "}
              </div>
              <div className="form-group">
                <label>{translator("EditItem-Name")}</label>{" "}
                <Tooltip text={translator("Item-Name-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  ref={register({ required: true, maxLength: 100 })}
                  defaultValue={item.name}
                />
                {errors.name && errors.name.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.name && errors.name.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength100")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="ddlStore">
                  {translator("EditItem-ItemGroup")}
                </label>
                <select name="itemGroupId" className="form-control">
                  <option value="-1">{translator("EditItem-Choose")}</option>
                  {itemGroups &&
                    itemGroups.map((g) => (
                      <option
                        key={g.id}
                        selected={item.itemGroupId === g.id}
                        value={g.id}
                      >
                        {g.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="ddlStore">
                  {translator("EditItem-UnitOfMeasure")}
                </label>{" "}
                <Tooltip text={translator("Item-UnitOfMeasure-Msg")} />
                <select
                  name="unitOfMeasureId"
                  ref={register({
                    validate: (value) => value !== "-1",
                  })}
                  className="form-control"
                >
                  <option value="-1">{translator("EditItem-Choose")}</option>
                  {unitOfMeasures &&
                    unitOfMeasures.map((x) => (
                      <option
                        selected={item.unitOfMeasureId === x.id}
                        value={x.id}
                        key={x.id}
                      >
                        {x.name}
                      </option>
                    ))}
                </select>
                {errors.unitOfMeasureId &&
                  errors.unitOfMeasureId.type === "validate" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
              </div>
            </fieldset>
          </div>

          <div
            className="container-fluid"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={handleCancel}
            >
              {translator("Btn-Cancel")}
            </button>
            &nbsp;
            <button className="btn btn-primary" type="submit">
              {translator("Btn-Save")}
            </button>
          </div>
        </form>
      )}
      <ResultModal
        show={resultModal.show}
        title={resultModal.title}
        text={resultModal.text}
        warningText={resultModal.warningText}
        btnClass={resultModal.btnClass}
        handleClose={handleCloseResultModal}
      />
    </CardWrap>
  );
};

export default EditRawMaterial;
